import './RoundLoader.scss'
import React from "react";

const RoundLoader = () => {
  return (
    <div className={"round-loader-wrapper"}>
      <div className={"loader-window"}>
        <div className={"loader-window_info"}>
          <h2>Loading...</h2>
          <span>Please wait</span>
        </div>

        <div className={"loader-window_preloader"}>
        </div>
      </div>
    </div>
  );
};

export default RoundLoader;
